var customer = {
    login: function () {
        if(!config.userLoggedIn && window.location.search.includes("admin")){
            $("#loginModal").modal("show");
        }

        $(document).on("submit", "#login-form", function (e) {
            e.preventDefault();

            var loginForm = document.getElementById("login-form");
            if (loginForm.checkValidity()) {
                fetch(loginForm.action, {
                    method: 'POST',
                    body: new URLSearchParams(new FormData(loginForm)),
                })
                    .then(function (response) { return response.json() })
                    .then(function (response) {
                        if (response) {
                            if (response.redirectUrl) {
                                $("#loginModal div.alert-danger").hide();
                                window.location = response.redirectUrl;
                            }
                            else if (response.errorMessage) {
                                $("#loginModal div.alert-danger").show();
                                $("#loginModal div.alert-danger small").text(response.errorMessage);
                            }else{
                                window.location.reload();
                            }
                        }
                    });
            }
        });
    },
    register: function () {
        $(document).on("submit", "#register-form", function (e) {
            e.preventDefault();

            var registerForm = document.getElementById("register-form");
            if (registerForm.checkValidity()) {
                fetch(registerForm.action, {
                    method: 'POST',
                    body: new URLSearchParams(new FormData(registerForm)),
                })
                    .then(function (response) { return response.json() })
                    .then(function (response) {
                        if (response) {
                            if (response.redirectUrl) {
                                $("#signModal div.alert-danger").hide();
                                // window.location = response.redirectUrl;
                                window.location.reload();
                            }
                            else if (response.errorMessage) {
                                $("#signModal div.alert-danger").show();
                                $("#signModal div.alert-danger small").text(response.errorMessage);
                            }
                        }
                    });
            }
        });
    },
    passwordRecovery: function () {
        $(document).on("submit", "#password-recovery-form", function (e) {
            e.preventDefault();

            var recoveryForm = document.getElementById("password-recovery-form");
            if (recoveryForm.checkValidity()) {
                fetch(recoveryForm.action, {
                    method: 'POST',
                    body: new URLSearchParams(new FormData(recoveryForm)),
                })
                    .then(function (response) { return response.json() })
                    .then(function (response) {
                        if (response) {
                            if (response.result) {
                                $("#forgotModal div.alert-danger").hide();
                                $("#forgotModal div.alert-info").show()
                                $("#forgotModal div.alert-info small").text(response.result);
                                $("#forgotModal input[type='email']").val("").hide();
                                $("#forgotModal #btn-submit-password-modal").hide();
                                $("#forgotModal #btn-close-password-modal").show();
                                $("#forgotModal #password-recovery-form").removeClass("was-validated");
                            }
                            else if (response.errorMessage) {
                                $("#forgotModal div.alert-danger").show();
                                $("#forgotModal div.alert-danger small").text(response.errorMessage);
                                $("#forgotModal input[type='email']").val("").show();
                                $("#forgotModal #btn-close-password-modal").hide();
                                $("#forgotModal #btn-submit-password-modal").show();
                                $("#forgotModal #password-recovery-form").removeClass("was-validated");
                            }
                        }
                    });
            }
        });
    },
    passwordRecoveryConfirm: function () {
        $("#passwordRecoveryModal").modal("show");

        $(document).on("submit","#passwordRecoveryForm", function (e) {
            e.preventDefault();

            var passwordRecoveryForm = document.getElementById("passwordRecoveryForm");
            if (passwordRecoveryForm.checkValidity()) {
                fetch(passwordRecoveryForm.action, {
                    method: 'POST',
                    body: new URLSearchParams(new FormData(passwordRecoveryForm)),
                })
                    .then(function (response) { return response.json() })
                    .then(function (response) {
                        if (response) {
                            if (response.result) {
                                $("#passwordRecoveryModal div.alert-danger").hide();
                                $("#passwordRecoveryModal div.alert-info").show();
                                $("#passwordRecoveryModal div.alert-info small").text(response.result);
                                setInterval(()=> {
                                    window.location = "/";
                                }, 2000);
                            }
                            else if (response.errorMessage) {
                                $("#passwordRecoveryModal div.alert-danger").hide().show();
                                $("#passwordRecoveryModal div.alert-danger small").text(response.errorMessage);
                            }
                        }
                    });
            }
        });
    }
};

$(function () {
    customer.login();
    customer.register();
    customer.passwordRecovery();
    customer.passwordRecoveryConfirm();
});
